import { configureStore, combineReducers } from '@reduxjs/toolkit'
import faceSwapReducer from './reducers/faceSwapReducer'
import loginReducer, { logout } from './reducers/loginReducer'
import sessionReducer from './reducers/generationSessionReducer'
import uiReducer from './reducers/uiReducer'
import homeReducer from './reducers/homeReducer'
import discoverReducer from './reducers/discoverReducer'
import uploadReducer from './reducers/uploadFileReducer'
import userProfile from './reducers/profileReducer'
import aiToolsReducer from './reducers/aiToolsReducer'
import dashBoardSelectedType from './reducers/dashBoardSelectedType'
import talkingAvatarReducer from './reducers/talkingAvatarReducer'
import eternalProfile from './reducers/eternalProfileReducer'
import transactionFilterReducer from './reducers/transactionFilter'
import voiceCloneReducer from './reducers/voiceCloneReducer'
import inviteUsersReducer from './reducers/inviteUsers'
import statusReducer from './reducers/statusReducer'
import  setConfiguration  from './reducers/configReducer'
import jobsReducer from './reducers/jobsReducer'
import consentReducer from './reducers/consentReducer'
import { unifiedJobStreamService } from '../services/unifiedJobStreamService'

const appReducer = combineReducers({
  auth: loginReducer,
  faceSwap: faceSwapReducer,
  ui: uiReducer,
  session: sessionReducer,
  homeData: homeReducer,
  discoverData: discoverReducer,
  uploadFile: uploadReducer,
  profileData: userProfile,
  aiTools: aiToolsReducer,
  talkingAvatar: talkingAvatarReducer,
  eternalProfileData: eternalProfile,
  dashBoardType: dashBoardSelectedType,
  transactionFilter: transactionFilterReducer,
  voiceClone: voiceCloneReducer,
  inviteUsers: inviteUsersReducer,
  userSubscriptionData : statusReducer,
  configuration: setConfiguration,
  jobs: jobsReducer,
  consent: consentReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT' || action.type === logout.type) {
    unifiedJobStreamService.disconnect()
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('active_jobs_persist_v1')
    }
    state = undefined
  }
  return appReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export default store
